<template>
  <div class="verify-slider" :class="{ 'is-pass': passed }">
    <div class="vs-bar" ref="bar">
      <div class="vs-fill" :style="{ width: fillWidth + 'px' }"></div>
      <span class="vs-tip">{{ passed ? successText : text }}</span>
      <div
        class="vs-handle"
        ref="handle"
        :style="{ transform: 'translateX(' + offset + 'px)' }"
        @mousedown="onStart"
        @touchstart.prevent="onStart"
      >
        <i :class="passed ? 'el-icon-check' : 'el-icon-d-arrow-right'"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifySlider",
  props: {
    text: { type: String, default: "按住滑块，拖动到最右侧" },
    successText: { type: String, default: "验证通过" },
    handleWidth: { type: Number, default: 40 },
  },
  data() {
    return {
      offset: 0,
      passed: false,
      dragging: false,
      startX: 0,
      maxOffset: 0,
    };
  },
  computed: {
    fillWidth() {
      return this.offset + this.handleWidth;
    },
  },
  mounted() {
    this.$nextTick(this.measure);
    window.addEventListener("resize", this.measure);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measure);
    this.unbind();
  },
  methods: {
    measure() {
      const bar = this.$refs.bar;
      const handle = this.$refs.handle;
      if (!bar) return;
      // 按实际渲染宽度计算，避免样式/主题改动后与 prop 不一致
      const handleW = handle ? handle.offsetWidth : this.handleWidth;
      this.maxOffset = Math.max(bar.clientWidth - handleW - 2, 0);
    },
    onStart(e) {
      // 每次按下都重新测量，防止挂载后布局变化导致可拖出右边界
      this.measure();
      if (this.passed || this.maxOffset <= 0) return;
      this.dragging = true;
      this.startX = e.touches ? e.touches[0].clientX : e.clientX;
      document.addEventListener("mousemove", this.onMove);
      document.addEventListener("mouseup", this.onEnd);
      document.addEventListener("touchmove", this.onMove, { passive: false });
      document.addEventListener("touchend", this.onEnd);
    },
    onMove(e) {
      if (!this.dragging) return;
      if (e.cancelable) e.preventDefault();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let off = clientX - this.startX;
      if (off < 0) off = 0;
      if (off > this.maxOffset) off = this.maxOffset;
      this.offset = off;
      if (off >= this.maxOffset - 2) {
        this.passed = true;
        this.offset = this.maxOffset;
        this.unbind();
        this.$emit("success");
      }
    },
    onEnd() {
      if (!this.dragging) return;
      if (!this.passed) this.offset = 0;
      this.unbind();
    },
    unbind() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.onMove);
      document.removeEventListener("mouseup", this.onEnd);
      document.removeEventListener("touchmove", this.onMove);
      document.removeEventListener("touchend", this.onEnd);
    },
    // 供父组件在登录失败后重置
    reset() {
      this.passed = false;
      this.offset = 0;
      this.$nextTick(this.measure);
    },
  },
};
</script>

<style scoped lang="scss">
.verify-slider {
  width: 100%;
}

.vs-bar {
  position: relative;
  height: 42px;
  background: #f4f6f9;
  border: 1px solid #e3e8ef;
  border-radius: 3px;
  overflow: hidden;
  user-select: none;
}

.vs-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(28, 78, 138, 0.12), rgba(28, 78, 138, 0.3));
  transition: width 0.06s linear;
}

.vs-tip {
  position: relative;
  display: block;
  line-height: 40px;
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  pointer-events: none;
}

.vs-handle {
  position: absolute;
  left: 1px;
  top: 1px;
  width: 40px;
  height: 38px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1c4e8a;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f2f7fc;
  }
}

.is-pass {
  .vs-fill {
    background: linear-gradient(90deg, #a5d6a7, #66bb6a);
  }

  .vs-tip {
    color: #43a047;
  }

  .vs-handle {
    color: #43a047;
    cursor: default;
  }
}
</style>
